var map = {
	"./2025_ak_mkw_nrw_rgb.png": 7274,
	"./DasSchaubuedchen_Logo_RGB_RZ.png": 7305,
	"./StadtBochum_Logo_Blau.png": 6309,
	"./kulturbuero-und-stadt-dortmund.jpeg": 5284,
	"./lwl.jpeg": 4999
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1378;
module.exports = webpackAsyncContext;